import React from 'react'
import Checkbox from "react-custom-checkbox";
import { FiCheck } from "react-icons/fi";

export default function CheckBox(props: any) {

  
    return (
      <label className="flex flow-row">
      <Checkbox
                icon={<FiCheck color="#FFF" size={14} />}
                name="my-input"
                labelStyle={{marginLeft: 10, color: "#383e40" }}
                disabled={props.isDisabled}
                checked={props.isChecked}
                onChange={(value)=>props.setIsChecked(value)}
                borderColor="#707070"
                borderWidth={props.isChecked ? 0 : 2}
                borderRadius={props.isChecked ? 0 : 2}
                style={props.isChecked ? { backgroundColor: '#68d56f', cursor: "pointer"} : { backgroundColor: '#f6f6f6', cursor: "pointer" }}
                containerClassName=""
                label={props.labelWithJsx ? null : props.label}
      />
      <span 
      style={{marginLeft: "10px", color: "rgb(56, 62, 64)"}} 
      className={`${props.labelWithJsx ? "inline" : "hidden"}`}
      dangerouslySetInnerHTML={{__html: props.labelWithJsx}} >
      </span>
    </label>
    )
  }


